import { Item } from 'src/types/itemList';
import { ProductHighlight, VendorBooth, BoothContact } from 'src/types/vendorBooth';

export type VendorBoothAction =
  | {
      type: 'SetVendorBooth';
      payload: VendorBooth;
    }
  | {
      type: 'SetProductHighlights';
      payload: ProductHighlight[];
    }
  | {
      type: 'SetStartingItems';
      payload: Item[];
    }
  | {
      type: 'SetContacts';
      payload: BoothContact[];
    }
  | {
      type: 'UpdateProperty';
      payload: { property: string; value: string | number };
    };

export const vendorBoothReducer = (state: VendorBooth, action: VendorBoothAction): VendorBooth => {
  switch (action.type) {
    case 'SetVendorBooth':
      return { ...action.payload };
    case 'SetProductHighlights':
      const ph: ProductHighlight[] = action.payload;
      return { ...state, productHighlights: ph };
    case 'SetStartingItems':
      return { ...state, startingItems: [...action.payload] };
    case 'SetContacts':
      const c: BoothContact[] = action.payload;
      return { ...state, boothContacts: c };
    case 'UpdateProperty':
      const { property, value } = action.payload;
      let props = state.boothProperties.map((p) => {
        if (p.alias === property) {
          p.value = value;
        }
        return p;
      });
      return { ...state, boothProperties: props };
    default:
      return state;
  }
};
